// assets
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import HomeOutlined from '@ant-design/icons/HomeOutlined';
import DatabaseOutlined from '@ant-design/icons/DatabaseOutlined';
import NotificationOutlined from '@ant-design/icons/NotificationOutlined';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { LineChartOutlined, HomeOutlined, DatabaseOutlined, NotificationOutlined };

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: NavItemType = {
  id: 'group-dashboard',
  title: 'dashboard',
  icon: icons.HomeOutlined,
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'dashboard',
      subtitle: 'Overview of system insights and activities',
      type: 'item',
      url: '/dashboard',
      icon: icons.HomeOutlined
    },
    {
      id: 'tenant-dashboard',
      title: 'dashboard',
      subtitle: 'Overview of system insights and activities',
      type: 'item',
      url: '/tenant-dashboard',
      icon: icons.HomeOutlined
    },
    {
      id: 'contractor-dashboard',
      title: 'dashboard',
      subtitle: 'Overview of system insights and activities',
      type: 'item',
      url: '/contractor-dashboard',
      icon: icons.HomeOutlined
    },
    {
      id: 'no-permission',
      title: 'No Permission',
      subtitle: 'Please contact your administrator for access rights',
      type: 'item',
      url: '/no-permission',
      icon: icons.NotificationOutlined,
      visible: false,
      breadcrumbs: true
    },
  ]
};

export default dashboard;
